{
  "en": {
    "applications": "approved",
    "auth": "approved",
    "calendar": "approved",
    "chat": "approved",
    "circle": "approved",
    "common": "approved",
    "community": "approved",
    "companion": "approved",
    "consent": "approved",
    "copy": "approved",
    "crisis": "approved",
    "dashboard": "approved",
    "emails": "approved",
    "feedback": "approved",
    "forms": "approved",
    "grants": "approved",
    "health": "approved",
    "help": "approved",
    "landing": "approved",
    "legal": "approved",
    "memorial": "approved",
    "money": "approved",
    "nav": "approved",
    "notifications": "approved",
    "onboarding": "approved",
    "profile": "approved",
    "settings": "approved",
    "shell": "approved",
    "tasks": "approved",
    "validation": "approved"
  },
  "es": {
    "applications": "machine",
    "auth": "machine",
    "calendar": "machine",
    "chat": "machine",
    "circle": "machine",
    "common": "machine",
    "community": "machine",
    "companion": "machine",
    "consent": "machine",
    "copy": "machine",
    "crisis": "machine",
    "dashboard": "machine",
    "emails": "machine",
    "feedback": "machine",
    "forms": "machine",
    "grants": "machine",
    "health": "machine",
    "help": "machine",
    "landing": "machine",
    "legal": "machine",
    "memorial": "reviewed",
    "money": "machine",
    "nav": "machine",
    "notifications": "machine",
    "onboarding": "machine",
    "profile": "machine",
    "settings": "draft",
    "shell": "machine",
    "tasks": "machine",
    "validation": "machine"
  },
  "fr": {
    "applications": "machine",
    "auth": "machine",
    "calendar": "machine",
    "chat": "machine",
    "circle": "machine",
    "common": "machine",
    "community": "machine",
    "companion": "machine",
    "consent": "machine",
    "copy": "machine",
    "crisis": "machine",
    "dashboard": "machine",
    "emails": "machine",
    "feedback": "machine",
    "forms": "machine",
    "grants": "machine",
    "health": "machine",
    "help": "machine",
    "landing": "machine",
    "legal": "machine",
    "memorial": "reviewed",
    "money": "machine",
    "nav": "machine",
    "notifications": "machine",
    "onboarding": "machine",
    "profile": "machine",
    "settings": "draft",
    "shell": "machine",
    "tasks": "machine",
    "validation": "machine"
  },
  "pt": {
    "applications": "machine",
    "auth": "machine",
    "calendar": "machine",
    "chat": "machine",
    "circle": "machine",
    "common": "machine",
    "community": "machine",
    "companion": "machine",
    "consent": "machine",
    "copy": "machine",
    "crisis": "machine",
    "dashboard": "machine",
    "emails": "machine",
    "feedback": "machine",
    "forms": "machine",
    "grants": "machine",
    "health": "machine",
    "help": "machine",
    "landing": "machine",
    "legal": "machine",
    "memorial": "reviewed",
    "money": "machine",
    "nav": "machine",
    "notifications": "machine",
    "onboarding": "machine",
    "profile": "machine",
    "settings": "draft",
    "shell": "machine",
    "tasks": "machine",
    "validation": "machine"
  },
  "zh": {
    "applications": "machine",
    "auth": "machine",
    "calendar": "machine",
    "chat": "machine",
    "circle": "machine",
    "common": "machine",
    "community": "machine",
    "companion": "machine",
    "consent": "machine",
    "copy": "machine",
    "crisis": "machine",
    "dashboard": "machine",
    "emails": "machine",
    "feedback": "machine",
    "forms": "machine",
    "grants": "machine",
    "health": "machine",
    "help": "machine",
    "landing": "machine",
    "legal": "machine",
    "memorial": "reviewed",
    "money": "machine",
    "nav": "machine",
    "notifications": "machine",
    "onboarding": "machine",
    "profile": "machine",
    "settings": "draft",
    "shell": "machine",
    "tasks": "machine",
    "validation": "machine"
  }
}
